import { Controller } from 'stimulus';
import Swiper from 'swiper';
import { Mousewheel, Navigation } from 'swiper/modules';

class HorizontalScroll extends Controller {
  connect() {
    Swiper.use([Mousewheel, Navigation]);

    this.swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 32,
      freeMode: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: '.horizontalScrollRowArrowNext',
        prevEl: '.horizontalScrollRowArrowPrev',
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}

HorizontalScroll.targets = [
  'leftArrow',
  'rightArrow',
];

export default HorizontalScroll;
